import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as AddQuestionImg} from '../../assets/chat04/add-question.svg';
import {ReactComponent as AddQuestionSmallImg} from '../../assets/chat04/add-question-sm.svg';
import {ReactComponent as AddQuestionMediumImg} from '../../assets/chat04/add-question-md.svg';
import {ReactComponent as AddQuestionLargeImg} from '../../assets/chat04/add-question-lg.svg';
import {ReactComponent as AlgorithmImg} from '../../assets/chat04/algorithm.svg';
import {ReactComponent as ReQuestionImg} from '../../assets/chat04/re-question.svg';
import {ReactComponent as ReQuestionSmallImg} from '../../assets/chat04/re-question-sm.svg';
import {ReactComponent as ReQuestionMediumImg} from '../../assets/chat04/re-question-md.svg';
import {ReactComponent as ReQuestionLargeImg} from '../../assets/chat04/re-question-lg.svg';

export default function Chat04() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481x) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const getReQuestionImg = () => {
        if (mobileSmall) return ReQuestionSmallImg;
        if (mobileMedium) return ReQuestionMediumImg;
        if (mobileLarge) return ReQuestionLargeImg;

        return ReQuestionImg;
    };

    const getAddQuestionImg = () => {
        if (mobileSmall) return AddQuestionSmallImg;
        if (mobileMedium) return AddQuestionMediumImg;
        if (mobileLarge) return AddQuestionLargeImg;

        return AddQuestionImg;
    };

    const dataMap = [
        { 
            type: 're-question',
            title: '재질문',
            subTitle: '모호한 질문은 선택지를 통해 정확하게 만들어요',
            Image: getReQuestionImg()
        },
        { 
            type: 'add-question',
            title: '추가 질문',
            subTitle: '연관되는 선택지를 통해 질문을 이어가요',
            Image: getAddQuestionImg()
        }
    ];

    return (
        <FeatureCardBox
            type='algorithm'
            IconImage={AlgorithmImg}
            keyword='질문 알고리즘'
            title={mobileSmall ? <>정확한 답변을 위한<br />프로세스를 제공해요!</> : '정확한 답변을 위한 프로세스를 제공해요!'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
        />
    );
}
